// extracted by mini-css-extract-plugin
export default {"EditProfile":"EditProfile_EditProfile__tfBL+","form":"EditProfile_form__SdTZ6","userImage":"EditProfile_userImage__Az-H5"};